var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 0a9.5 9.5 0 1 0 0 19 9.5 9.5 0 0 0 0-19Zm0 3.194a1.913 1.913 0 1 1 0 3.825 1.913 1.913 0 0 1 0-3.825Zm2.022 12.612H7.478v-1.618H8.8v-3.934h-.808V8.637h2.426v5.551h1.103v1.618Z",
    fill: "#D0DF00"
  })));
};
export default SvgInfo;